import { Button, Col, Divider, notification, Popconfirm, Row } from 'antd';
import { commonApi } from 'api/commonApi';
import { useAppSelector } from 'app/hooks';
import AddEditFormInverter from 'components/Common/Modal/AddEditFormInverter';
import { selectInverterInfo } from 'features/Inverter/inverterSlice';
import { selectIsDisable } from 'features/Login/authSlice';
import { selectPlantInfo } from 'features/Plant/plantSlice';
import { objectDevice } from 'models';
import moment from 'moment';
import * as React from 'react';
import { FiChevronLeft, FiEdit } from 'react-icons/fi';
// import style from '../Components.module.scss';
import style from './InverterInfo.module.scss';
export interface InverterInfoProps {
  isShowDevicesDetail: boolean;
  setIsShowDevicesDetail: (value: boolean) => void;
  // setGatewayList: (value: GatewayInfo[]) => void;
}

export default function InverterInfo({
  isShowDevicesDetail,
  setIsShowDevicesDetail,
}: InverterInfoProps) {
  const itemInverter = useAppSelector(selectInverterInfo);
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  // const [isEvent, setIsEvent] = React.useState<boolean>(true);
  const isEvent: boolean = true;
  const isDisable = useAppSelector(selectIsDisable);
  const itemPlant = useAppSelector(selectPlantInfo);
  const [SensorType, setSensorType] = React.useState<objectDevice[]>();
  React.useEffect(() => {
    if (itemPlant) {
      (async () => {
        const res = await commonApi.fetchDeviceProfile({
          text_search: 'Inverter',
          _limit: 600,
          _page: 0,
        });
        setSensorType(res.data);
      })();
    }
  }, []);
  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const onDeleteItemGateway = async (value: string) => {
    // await gatewayApi.remove(value);
    // const res = await gatewayApi.fetchGateways({ _limit: 5, _page: 0 });
    // setGatewayList(res.data);
    openNotificationWithIcon('success', 'Delete gateway successfully');
    setIsShowDevicesDetail(!isShowDevicesDetail);
  };

  return itemInverter ? (
    <Row className={style.root}>
      <Row className={style.header_info}>
        <Col span={19} className={style.header_label_info}>
          {!isShowDevicesDetail && (
            <FiChevronLeft
              style={{ marginRight: '5px', cursor: 'pointer' }}
              onClick={() => setIsShowDevicesDetail(!isShowDevicesDetail)}
            />
          )}
          Devices Information
        </Col>
        <Col span={5} className={style.header_group_btn}>
          <Popconfirm
            placement="bottomLeft"
            title="Sure to delete?"
            onConfirm={() => onDeleteItemGateway(itemInverter.id)}
          >
            <Button disabled={isDisable} className={style.btn_delete}>
              Delete
            </Button>
          </Popconfirm>
          <Button
            className={style.btn_edit}
            onClick={() => {
              setIsModalVisible(!isModalVisible);
            }}
          >
            Edit
            <FiEdit style={{ marginLeft: '10px' }} />
          </Button>
        </Col>
      </Row>
      <div className={style.main_detail}>
        <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
          General Info
        </Divider>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Code
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemInverter?.code}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Label
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemInverter?.label}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Model
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemInverter?.model ? `${itemInverter?.model}` : 'N/A'}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Serial Number
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemInverter?.serial_number ? `${itemInverter?.serial_number}` : 'N/A'}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Installtion Date
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemInverter.installation_date &&
              moment(itemInverter.installation_date).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Created Time
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemInverter.created_time &&
              moment(itemInverter.created_time).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Gateway
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemInverter.gateway ? `${itemInverter.gateway}` : 'N/A'}
          </Col>
        </div>
        <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
          Connection Info
        </Divider>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Active
          </Col>
          <Col span={19} className={style.values_plant_information} style={{ color: '#2194FF' }}>
            {itemInverter.active ? 'Active' : 'Inactive'}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Last activity time
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {moment(itemInverter?.last_activity_time).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Last connect time
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {moment(itemInverter?.last_connect_time).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Last disconnect time
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {moment(itemInverter?.last_disconnect_time).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
      </div>
      {SensorType && (
        <AddEditFormInverter
          SensorType={SensorType}
          isEvent={isEvent}
          itemInverter={itemInverter}
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
        />
      )}
    </Row>
  ) : null;
}
